<template>
<div class="wrap">
   <div class="title">城房案场-置业顾问《用户协议》</div>
   <div class="content_title">1.特别提醒</div>
   <div class="content">1.1在您注册成为城房案场-置业顾问平台（以下简称城房案场）的用户或使用、接受城房案场的服务之前，您确认已充分阅读、理解并接受本协议的全部内容，并同意遵循本协议的所有约定；</div> 
   <div class="content">1.2城房案场有权随时对本协议内容进行单方面的变更，并以在城房案场公告的方式予以公布，无需另行单独通知；</div> 
   <div class="content">1.3若您在本协议内容公告变更后继续使用、接受城房案场的服务，表示您已充分阅读、理解并接受修改后的协议内容，并同意遵循修改后协议的所有约定；若您不同意修改后的协议内容应当立即停止使用城房案场的服务，并告知城房案场进行账户注销。</div> 
   <div class="content_title">2.定义</div>
   <div class="content">2.1「城房案场」指合肥城房宝数字科技有限公司运营的APP；</div> 
   <div class="content">2.2「城房案场用户」指同意参加城房案场平台合作，遵守本协议约定，完成城房案场用户在线注册并具备履行平台合作所需的相应能力的个人。</div> 
   <div class="content_title">3.注册条款</div>
   <div class="content">3.1城房案场的用户，需要具有法律规定的完全民事权利和民事行为能力，是能够独立承担民事责任的自然人。不具备前述主体资格应当立即停止注册或停止使用城房案场的服务，由此导致的一切后果由其个人及其监护人承担。</div> 
   <div class="content">3.2注册城房案场的用户在进行某些特定行为前，需要提供注册人的姓名、身份证号码等相关信息及相应的证件资料。</div> 
   <div class="content">3.3在注册成为城房案场的用户或使用、接受城房案场的服务时，需同意并履行如下义务：</div> 
   <div class="content">3.3.1在注册时，向城房案场提供真实、准确、即时、完整的注册信息；</div> 
   <div class="content">3.3.2在确知或者有合理理由怀疑您提供的信息不真实、不准确、不即时、不完整时，城房案场有权暂停或终止服务；</div> 
   <div class="content">3.3.3因用户注册时提供的手机等联系方式无法及时与用户取得联系，导致用户在使用城房案场服务过程中产生任何损失或增加费用的，由用户自行承担；</div> 
   <div class="content">3.3.4城房案场有权以各种方式（包括但不限于电子邮件、手机短信等）发送与城房案场所提供服务相关的各类商业信息，如拒绝继续接收上述商业信息，必须通过书面方式通知城房案场；</div> 
   <div class="content">3.3.5 城房集团其他专业子公司如有明确的利益冲突规避及岗位隔离要求的，其相应岗位的员工或代理人不得擅自注册成为城房案场平台代理人。</div> 
   <div class="content_title">4.用户行为管理</div>
   <div class="content">4.1用户在使用城房案场服务时，应遵守国家法律规定、城房案场的相关协议及规则。不得从事以下行为：</div> 
   <div class="content">4.1.1不得利用「城房案场」 进行虚假宣传；</div> 
   <div class="content">4.1.2不得利用「城房案场」并以个人名义从事互联网地产销售；</div> 
   <div class="content">4.1.3不得从事非法集资、欺诈、洗钱等违法违规行为；</div> 
   <div class="content">4.1.4不得从事各种对北京城房造成经济及声誉损失的行为；</div> 
   <div class="content">4.1.5不得从事城房案场用户授权范围外的行为；</div> 
   <div class="content">4.1.6不得通过城房案场发布、传播有关宗教、种族或性别等的贬损言辞；</div> 
   <div class="content">4.1.7不得侵犯党和国家利益的言论；骚扰、滥用或威胁其他用户的信息、广告信息；</div> 
   <div class="content">4.1.8不得侵犯任何第三方著作权、专利、商标、商业秘密或其他专有权利或名誉权的信息；</div> 
   <div class="content">4.1.9不得干扰或破坏城房案场或与城房案场相连的服务器和网络及从事其他干扰或破坏城房案场服务的活动，将城房案场作任何非法用途；</div> 
   <div class="content">4.1.10城房案场用户需遵守注册协议内的各项约定，对于利用城房案场用户身份在互联网线上或线下从事的违法违规行为，均由用户自行承担所有责任，同时我司会配合司法机关进行法律责任追究。用户违法违规行为损害到城房案场合法权益时，我司将通过法律手段进行维权。</div> 
   <div class="content_title">5.用户账户管理</div>
   <div class="content">5.1在完成城房案场的用户注册程序或以城房案场允许的其他方式实际使用城房案场服务时，城房案场会提供唯一ID号的城房案场账户（以下亦称「账户」）。 用户可以对账户设置用户名、密码，通过该用户名、密码或经城房案场授权的其他关联或合作网站的用户名密码登录城房案场。用户设置的用户名不得违反法律规定、不得侵犯他人合法权益。</div> 
   <div class="content">5.2用户应当妥善保管用户名和密码，因密码泄露所致的损失自行承担。用户不得向其他任何人泄露用户名及密码，如发现任何人冒用或盗用用户名及密码或有任何其他可能危及账户安全的情形时，用户应当立即以有效方式通知城房案场，要求城房案场暂停相关服务。城房案场对在合理时间内采取行动但期间已产生的不良后果（包括但不限于用户的任何损失）不承担任何责任。</div> 
   <div class="content">5.3除非有法律依据且征得城房案场的同意，否则，用户的用户名和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。</div> 
   <div class="content_title">6.费用</div>
   <div class="content">6.1注册城房案场的用户及使用相应服务是免费的。城房案场保留修改费用条款的权利，一旦费用条款被修改，将立即在App内进行公示。</div> 
   <div class="content">6.2城房案场不负责对用户因使用城房案场的服务而需支付的软硬件、税收及其他费用。城房案场有权在未经通知的情况下随时改变或不继续提供某些或全部服务（暂时性的或永久的）。</div> 
   <div class="content_title">7.信息授权条款</div>
   <div class="content">7.1城房案场非常重视用户的隐私权，将会尽最大努力保护用户的个人信息。除法律法规规定的情形外，未经用户许可城房集团不会向第三方公开、透露用户个人信息。</div> 
   <div class="content">7.2城房案场拥有完善的信息管理安全制度，为保障用户个人信息的安全，对重要用户信息采用了专业的加密存储与传输方式，以免用户信息遭受未经授权的访问、使用或披露。</div> 
   <div class="content">7.3用户在使用城房案场的过程中，需要提供一些必要的个人信息，如姓名、手机号码、身份证号等，因产品服务与实际使用功能相关联，若您提供的信息不完整、不真实，则可能在使用过程中受限或无法使用部分功能。</div>
   <div class="content">7.4除法律另有规定之外，城房集团有权将用户提供给城房集团的信息、享受城房集团服务产生的信息（包括本条款签署之前提供和产生的信息）以及城房集团根据本条款约定查询、收集的信息，用于城房集团及其因服务必要委托的合作伙伴为用户提供服务、推荐产品、开展市场调查与信息数据分析。</div> 
   <div class="content">7.5除法律另有规定之外，基于为用户提供更优质服务和产品的目的，城房集团有权因服务必要开展合作的伙伴提供、查询、收集用户的信息。</div> 
   <div class="content">7.6前述「信息」可能包括但不限于用户的身份信息、财产信息、账户信息、信用信息、交易信息、行踪轨迹信息、电子设备信息、电子设备操作日志及其他与用户相关的信息。</div>
   <div class="content">7.7如您不同意上述授权条款的部分或全部，应通过书面方式通知城房案场取消或变更授权。</div> 
   <div class="content">7.8本条款自用户签署时生效，具有独立法律效力，不受本条款所属合同或协议成立与否及效力状态变化的影响。</div> 
   <div class="content">7.9本条款所称「城房集团」是指北京城房科技集团有限公司及其直接或间接控股的公司，北京城房科技集团有限公司直接或间接作为其单一最大股东的公司，以及北京城房科技集团有限公司以其他方式直接或间接控制或有重大影响的主体。</div>
   <div class="content_title">8.责任声明</div>
   <div class="content">8.1对使用城房案场而产生的风险由用户自己承担，城房案场明确不提供任何明示或者默示的担保。</div> 
   <div class="content">8.2城房案场对下列事项不作任何陈述与保证：</div> 
   <div class="content">8.2.1城房案场的服务符合用户的预期要求或经验；</div>
   <div class="content">8.2.2用户使用城房案场的服务后所产生的任何行为，如购买或获得的任何产品、服务、信息或其他事物等，符合用户的预期要求或经验；</div> 
   <div class="content">8.2.3用户需独立承担因网站意外中断、操作或传输的迟延、电脑病毒、网络连接故障、未经授权的进入等引起的损失。</div> 
   <div class="content">8.3用户因违反城房案场注册协议或其他有关的法律、法规，而导致有第三方对北京城房科技集团有限公司提起诉讼或索赔要求时，用户需要赔偿北京城房科技集团有限公司因此遭受的所有损失，包括但不限于合理的律师费。</div>
   <div class="content">8.4城房案场对用户在城房案场上公布的信息中查找到的内容不负责任，对信息的即时性、安全性和正确性也不作保证。对通过城房案场获取的任何信息，用户需自己甄别，自负风险；对因下载或引用城房案场的数据、信息而造成的用户计算机系统损坏或数据丢失，城房案场不负责任。</div> 
   <div class="content">8.5城房案场对用户使用城房案场上公布的或其服务中的建议和资讯而造成的损失或伤害以及用户相信城房案场上的公布的或其服务中的建议和资讯而做出的决定或采取的行动不负责任。对城房案场提供的部分或所有服务不满，用户唯一的补救措施是停止使用这些服务。</div> 
   <div class="content">8.6城房案场含有与其他网站的链接。城房案场与链接的网站有合作关系，但并不能控制这些网站及其所提供的资源，所以城房案场对链接网站上的内容、广告、服务、产品信息的真实有效性不负责任，并且对因链接网站上的内容、广告、服务、产品信息的失实而造成的损失不负任何法律责任。</div>
   <div class="content">8.7鉴于互联网的特殊性，因黑客攻击、互联网连通中断或者系统故障等情形给用户造成的损失，城房案场不承担责任。</div>
   <div class="content_title">9.知识产权声明</div>
   <div class="content">9.1城房案场上所有可阅读的资料等都受到《中华人民共和国著作权法》等的法律保护。</div> 
   <div class="content">9.2城房案场上所有内容的选材、整理、编排、排版，以及由城房案场创作的文字、图片等作品的著作权，无论是否明示，均属城房案场所有。 任何组织或个人未经城房案场书面许可，不得修改、出版、传播、参与传播、销售、制作衍生作品，或以其他任何方式使用整体或部分的城房案场上的内容。</div> 
   <div class="content">9.3城房案场对其开发或者合作开发的系统等享有知识产权。城房案场的所有权利受法律保护。</div>
   <div class="content">9.4城房案场，是北京城房科技集团有限公司所有、使用的商标。</div> 
   <div class="content">9.5所有其他在城房案场上出现的商标为它们各自的权利人所有。</div> 
   <div class="content">9.6城房案场尊重和保护他人的知识产权。不允许在没有著作权、商标权或其他专有权权利人明确许可的情况下，发布或者传播任何可能侵犯他人权利的信息、图片。行为人承担由此产生的全部责任。</div>
   <div class="content_title">10.协议中止与终止</div>
   <div class="content">出现以下情形，城房案场有权在告知或未经告知的情况下中止或终止协议及部分或全部服务，无须因此承担任何责任，且保留追究用户下列行为法律责任的权利：</div> 
   <div class="content">10.1向城房案场提供的信息或资料不真实、不准确、不即时、不完整；</div> 
   <div class="content">10.2实施或计划实施破坏、攻击城房案场的电脑系统、网络的完整性，或者试图擅自进入城房案场电脑系统、网络；</div>
   <div class="content">10.3使用或提供含有毁坏、干扰、截取或侵占任何系统、数据或个人资料的任何电脑病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他破坏性程序；</div> 
   <div class="content">10.4盗用他人在城房案场上的用户名或密码；</div> 
   <div class="content">10.5未经城房案场书面同意，擅自允许他人使用城房案场的服务（包括但不限于擅自允许他人使用其用户名或密码，或者擅自将其用户名或密码转让给他人的），或者通过城房案场获得相关信息。</div>
   <div class="content">10.6出现其他任何违法、违纪或违约的情形。协议中止期间，用户的账户将被冻结，用户将无法使用城房案场平台部分或全部功能，也不再享有任何形式的平台利益。即使注册协议重新生效，用户也无权对协议中止期间任何利益进行回溯。一旦协议、服务被终止，城房案场有权随时删除您在城房案场的注册信息及相关资料；对用户在服务中止或终止前的行为，城房案场保留追究法律责任的权利。</div> 
   <div class="content_title">11.法律适用及管辖</div>
   <div class="content">本协议条款的解释及适用，以及与本协议条款有关的争议，均应依照中华人民共和国法律（不包含港澳台地区的法律）予以处理，并以北京城房科技集团有限公司所在地人民法院为管辖法院。</div> 
  </div>
</template>
<script>
export default {
    name: 'PadAgreement',
    data(){
        return{
            
        }
    }
}
</script>

<style lang="less" scoped>
  @import url(../assets/styles/common.css);
</style>